// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 687 ? "fe75db45" : chunkId) + "." + {"71":"ec3a978fa9844ab0","490":"31d967b6fb66de33","537":"24f02c35a0c31e69","601":"6373029d5efc1f1f","687":"6c8ba6a65e6de12c","722":"b4a13f4f7576d6f6","755":"ac644ba33d0c5fa2"}[chunkId] + ".js";
};